export const CloseIcon = ({ bgColor }: { bgColor?: string }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
    fill={bgColor}
  >
    <circle
      cx="9.92981"
      cy="9"
      r="9"
    />
    <path
      d="M6.13875 11.7822C5.86016 12.0608 5.86016 12.5125 6.13875 12.7911C6.41733 13.0696 6.86901 13.0696 7.1476 12.7911L9.92981 10.0088L12.712 12.7911C12.9906 13.0696 13.4423 13.0696 13.7209 12.7911C13.9995 12.5125 13.9995 12.0608 13.7209 11.7822L10.9387 9L13.7209 6.21779C13.9995 5.9392 13.9995 5.48752 13.7209 5.20894C13.4423 4.93035 12.9906 4.93035 12.712 5.20894L9.92981 7.99115L7.1476 5.20894C6.86901 4.93035 6.41733 4.93035 6.13875 5.20894C5.86016 5.48752 5.86016 5.9392 6.13875 6.21779L8.92096 9L6.13875 11.7822Z"
      fill="currentColor"
    />
  </svg>
);
